import React from "react";

import Background from "../components/Background";
import MainPage from "../components/MainPage";
const Home = () => {
  return (
    <div className="custom-scrollbar">
      <Background/>
      <MainPage/>
    </div>
  );
};

export default Home;
